<template>
  <div id="login">
    <div class="logo-bar">
      <img src="@/assets/img/logo-scm.png" />
    </div>
    <div class="loginBox" @click="changeImage(3)">
      <div class="auth-form">
        <!-- <div class="panfish">
          <img :src="imageURL" alt="" />
        </div> -->
        <!-- 关闭按钮 -->
        <van-tabs v-model="active" animated>
          <van-tab title="登录">
            <!-- 账号密码登录 -->
            <van-cell-group v-show="!isShowSMSLogin">
              <van-field v-model="editItem.Mobile" required clearable label="手机号" maxlength="11"
                @click.stop="changeImage(0)" :error-message="phoneNumberRight ? '' : '手机号格式不正确'" placeholder="手机号" />
              <van-field v-model="editItem.Password" type="password" label="密码" placeholder="密码" required
                @click.stop="changeImage(1)" autocomplete />
              <!-- 手机号快捷登录 -->
            </van-cell-group>
            <van-cell-group v-show="isShowSMSLogin">
              <van-field v-model="editItem.Mobile" required clearable maxlength="11" label="手机号" placeholder="手机号"
                :error-message="phoneNumberRight ? '' : '手机号格式不正确'" />
              <van-field v-model="imgUrlData" center clearable maxlength="4" placeholder="请输入验证码">
                <img class="verificationImage" :src="CaptchaUrl" alt="captcha" @click="onReloadCaptcha" ref="imgCaptcha"
                  slot="button" />
              </van-field>
              <van-field center clearable required label="验证码" placeholder="验证码" maxlength="6" v-model="editItem.Captcha">
                <van-button slot="button" size="small" type="primary" v-if="!countDown" :disabled="captchaDisable"
                  ref="getAuthBtn" @click="onSendLoginSms">发送验证码</van-button>
                <van-button slot="button" size="small" type="primary" disabled="" v-else>已发送{{ countDown }}s</van-button>
              </van-field>
            </van-cell-group>
            <van-button type="info" size="large" style="margin-top: 0.18rem" @click="login">登录</van-button>
            <div class="lnks">
              <div class="switchLogin" @click="switchLogin">
                {{ this.isShowSMSLogin ? "账号密码登录" : "短信验证码登录" }}
              </div>
              <div class="reg-lnk">
                <router-link to="/register"> 还没账号？立即注册</router-link>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="content_footer">
      ©{{ new Date().getFullYear() }} 深圳市正能量供应链服务有限公司 <br />
      粤ICP备19017994号-1
    </div>
  </div>
</template>

<script type="text/javascript">
import { Toast } from "vant";
import { signInByMobile, SignInBySms, SendLoginSms } from "~/api/user";
import { loadUser } from "~/services/UserService";
import { saveData, getData } from "~/services/RememberService";
import * as captchaService from "~/services/captchaService";
import { isEmptyStr, regMobile } from "~/script/utils";

const loginImage = require("~/images/login/normal.png");

export default {
  name: "Login",
  data() {
    return {
      countDown: 0,
      active: 0,

      editItem: {
        Mobile: "",
        Captcha: "",
        Password: "",
        PasswordInputType: "password",
      },

      CaptchaUrl: "",
      imgUrlData: "",

      isShowSMSLogin: false,
      switchLoginMsg: "账号密码登录",
      imageURL: loginImage,
      smsCaptchaResult: null,
      userInfo: null,
    };
  },
  computed: {
    // 1.手机号码验证
    phoneNumberRight() {
      const value = this.editItem.Mobile;
      // 1.1 当输入的手机号大于10位进行验证
      if (value.length > 10) {
        return /[1][3,4,5,6,7,8][0-9]{9}$/.test(value);
      }
      return true;
    },
    // 2.发送验证码按钮显示
    captchaDisable() {
      if (this.editItem.Mobile.length > 10 && this.phoneNumberRight) {
        return false;
      }

      return true;
    },
  },
  methods: {
    changeImage(index) {
      if (index == 0) {
        this.imageURL = require("./../../images/login/greeting.png");
      } else if (index == 1) {
        this.imageURL = require("./../../images/login/blindfold.png");
      } else {
        this.imageURL = require("./../../images/login/normal.png");
      }
    },

    async login() {
      // eslint-disable-next-line camelcase
      const validateError = this.validateLogin();
      if (validateError) {
        Toast.fail(validateError);
        return;
      }

      const { editItem, isShowSMSLogin } = this;
      saveData({
        LoginMobile: editItem.Mobile,
      });

      const { sendData } = this.getLoginData();

      if (!isShowSMSLogin) {
        await signInByMobile(sendData);
      } else {
        await SignInBySms(sendData);
      }

      await loadUser().then(() => {
        const { redirect } = this.$route.query;
        if (redirect) {
          this.$router.push(redirect);
          return;
        }

        this.$router.push("/");
      });
    },

    validateLogin() {
      const { isShowSMSLogin } = this;
      if (!isShowSMSLogin) {
        return this.validateMobileLogin();
      } else {
        return this.validateSmsLogin();
      }

      // throw new Error("未找到校验函数。");
    },

    validateMobileLogin() {
      const { Mobile, Password } = this.editItem;
      if (!Mobile) {
        return "请输入手机号码";
      }

      const mobileRe = /^1\d{10}$/;
      if (!mobileRe.test(Mobile.trim())) {
        return "请输入正确的手机号码";
      }

      if (!Password) {
        return "请输入密码";
      }

      return null;
    },

    validateSmsLogin() {
      const { Mobile, Captcha } = this.editItem;
      if (!Mobile) {
        return "请输入手机号码";
      }

      const mobileRe = /^1\d{10}$/;
      if (!mobileRe.test(Mobile.trim())) {
        return "请输入正确的手机号码";
      }

      if (!Captcha) {
        return "请输入短信验证码";
      }

      return null;
    },

    switchLogin() {
      this.isShowSMSLogin = !this.isShowSMSLogin;
    },

    getMobileLoginData() {
      const { Mobile, Password } = this.editItem;
      const sendData = { Mobile, Password };
      return { sendData: { Mobile, Password } };
    },

    getSmsLoginData() {
      const { Mobile, Captcha } = this.editItem;
      return { sendData: { Mobile, Captcha } };
    },

    //处理登录方式
    getLoginData() {
      const { isShowSMSLogin } = this;
      if (!isShowSMSLogin) {
        return this.getMobileLoginData();
      } else {
        return this.getSmsLoginData();
      }

      throw new Error("未找到登录数据");
    },

    // 图文验证码
    // 图片验证码
    async onReloadCaptcha() {
      this.CaptchaUrl = await captchaService.getImageUrl();
    },

    async onSendLoginSms() {
      let imgUrlData = this.imgUrlData;
      let err = "";
      if (
        isEmptyStr(this.editItem.Mobile) ||
        !regMobile(this.editItem.Mobile)
      ) {
        err = "请输入正确的手机号码";
      } else if (!imgUrlData) {
        err = "请先输入图文验证码";
      }

      if (err) {
        Toast.fail(err);
        return false;
      }

      this.countDown = 10;
      this.timeIntervalID = setInterval(() => {
        this.countDown--;
        // 4.1 如果减到0 则清除定时器
        if (this.countDown == 0) {
          clearInterval(this.timeIntervalID);
        }
      }, 1000);

      const captchaId = await captchaService.getCaptchaId();
      let params = {
        Mobile: this.editItem.Mobile,
        CaptchaId: captchaId,
        Captcha: this.imgUrlData,
      };
      try {
        SendLoginSms(params);
        Toast.success("验证码已发送");
      } catch (e) {
        this.onReloadCaptcha();
        throw e;
      }
    },
  },

  async created() {
    const rememberData = getData();
    if (rememberData) {
      const { LoginMobile } = rememberData;
      this.editItem.Mobile = LoginMobile;
    }
    await this.onReloadCaptcha();
  },
};
</script>
<style lang="less" scoped>
#login {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .logo-bar {
    background-color: #fff;
    padding: 0.05rem;

    img {
      height: 0.35rem;
    }
  }

  background: url("../../images/login/login_bng.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;

  .loginBox {
    padding: 0.1rem 0;
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    // position: fixed;
    opacity: 0.95;

    z-index: 500;

    .auth-form {
      position: relative;
      padding: 0.34rem;
      width: 4.8rem;
      max-width: 90%;
      font-size: 0.2rem;
      background-color: #fff;
      border-radius: 8px;
      box-sizing: border-box;
    }

    img {
      position: absolute;
      top: 0.2rem;
      left: 50%;
      width: 0.75rem;
      transform: translate(-50%, -70%);
      z-index: 1;

      @media screen and (max-width: 320px) {
        top: 0.085rem;
        transform: translate(-50%, -40%);
        width: 0.85rem;
      }
    }

    .closeButton {
      position: absolute;
      right: 0.085rem;
      top: 0.085rem;
    }

    .verificationImage {
      position: absolute;
      right: 0;
      width: 0.7rem;
      height: 0.3rem;
      margin-left: 0.8rem;
    }

    .switchLogin {
      text-align: left;
    }
  }

  .lnks {
    display: flex;

    div {
      width: 50%;
      margin-top: 0.085rem;
      font-size: 0.14rem;
      text-align: right;
    }
  }

  .title {
    padding: 0.085rem;
    font-size: 0.085rem;
    color: grey;
  }

  .agreement {
    // margin-top: 1.667rem;
    line-height: 0.18rem;
    color: #767676;
    font-size: 0.067rem;

    .agreement-box {
      color: blue;
    }
  }

  .content_footer {
    padding: 0.5em 0;
    text-align: center;
    color: #fff;
    background-color: #fff4;
  }
}
</style>
